import {
  sortByDate,
  sortCustomId,
  sortNumber,
  sortString,
  TableSortData,
} from "@pimo/pimo-components";
import { BasicItem, Project, ReportingItem } from "product-test-types";

export function sortProjects(
  items: Project[],
  sort: TableSortData<
    Project & {
      progress: number;
      severity: string;
      status: string;
      degreeOfCompletion: string;
      endDate: string;
      updateStatus: string;
    }
  >
): Project[] {
  switch (sort.key) {
    case "customId":
    case "id":
      items.sort((a, b) =>
        sortCustomId(a?.customId ?? "", b?.customId ?? "", sort.direction)
      );
      break;
    case "name":
      items.sort((a, b) =>
        sortString(a?.name ?? "", b?.name ?? "", sort.direction)
      );
      break;
    case "owner":
      items.sort((a, b) =>
        sortString(a?.owner ?? "", b?.owner ?? "", sort.direction)
      );
      break;
    case "severity":
      break;
    case "status":
      break;
    case "degreeOfCompletion":
      break;
    case "progress":
      items.sort((a, b) =>
        sortNumber(
          a._calculated?.averageProgress ?? -1,
          b._calculated?.averageProgress ?? -1,
          sort.direction
        )
      );
      break;
    case "endDate":
      items.sort((a, b) => sortByDate(a?.endDate, b?.endDate, sort.direction));
      break;
    case "updateStatus":
      break;
  }

  return items;
}

export function sortReportingItems(
  items: ReportingItem[],
  sort: TableSortData<ReportingItem & BasicItem>
): ReportingItem[] {
  switch (sort.key) {
    case "customId":
      items.sort((a, b) =>
        sortCustomId(a?.customId ?? "", b?.customId ?? "", sort.direction)
      );
      break;
    case "name":
      items.sort((a, b) =>
        sortString(
          a?.basicItem?.name ?? "",
          b?.basicItem?.name ?? "",
          sort.direction
        )
      );
      break;
    case "owner":
      items.sort((a, b) =>
        sortString(
          a?.basicItem?.owner ?? "",
          b?.basicItem?.owner ?? "",
          sort.direction
        )
      );
      break;
    case "dimension":
      items.sort((a, b) =>
        sortString(
          a?.basicItem?.dimension ?? "",
          b?.basicItem?.dimension ?? "",
          sort.direction
        )
      );
      break;
    case "maturity":
      items.sort((a, b) =>
        sortString(
          a?.basicItem?.maturity ?? "",
          b?.basicItem?.maturity ?? "",
          sort.direction
        )
      );
      break;
    case "severity":
      break;
    case "status":
      break;
    case "degreeOfCompletion":
      break;
    case "progress":
      items.sort((a, b) =>
        sortNumber(a.progress ?? -1, b.progress ?? -1, sort.direction)
      );
      break;
    case "budget":
      items.sort((a, b) =>
        sortNumber(
          a?.basicItem?.budget ?? -1,
          b?.basicItem?.budget ?? -1,
          sort.direction
        )
      );
      break;
    case "endDate":
      items.sort((a, b) =>
        sortByDate(a?.basicItem?.endDate, b?.basicItem?.endDate, sort.direction)
      );
      break;
    // TODO:: enable once update status has been implemented
    // case "updateStatus":
    //   break;
  }
  return items;
}
